import axios from 'axios';

/**
 * Axios instance for login, token refresh, and token validation only.
 * Intentionally has no interceptors so stale session state cannot block
 * or mutate credential requests.
 */
const authClient = axios.create();

export default authClient;
